<template>
  <div id="personal-wrapper" class="w-100 personal">
      <v-toolbar flat class="sub-toolbar">
        <!-- Esc salir 
        <img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' @click='showModal=false'>
        <label class='txt-footer-izq'>{{ $t('lang.comun.salir') }}</label>-->
        <v-btn @click="dialog2 = true"
               v-if="permitido('MOBILESTORE.CONTROLUSER.NEWVEND') || $store.getters.isAdminSYS4"
               flat
               text
               class="ma-0 primary-color rounded-0">
        <!--<img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif' >-->
        <v-icon class="mr-2">person_add</v-icon>
        <!--{{ $t('lang.personas.addempleado') }}--> Crear nuevo empleado
        </v-btn>
        <v-btn @click="dialog1 = true"
               flat
               text
               class="ma-0 primary-color rounded-0">
        <!--<img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif' >-->
        <v-icon class="mr-2">manage_accounts</v-icon>
        {{ $t('lang.personas.addempleado') }}
        </v-btn>
      </v-toolbar>
    <div id='content'>
      <div class="margin-top px-2">
        <main>
          <div v-for='(persona, index) in personasMostrar' :key='index'>
            <div @click="editarPersona(persona.mspersonauid)" class="d-flex">
              <v-card class="ficha px-3 py-3 w-100 mt-3 mr-2">
               <v-avatar
                size="100px"
                class="mr-3"
              >
                <!--<img class="avatar" v-if='persona.mspersonaimagen === null || persona.mspersonaimagen === ""' :src='require("@/assets/images/no_photo.png")'>-->
                <v-img class="error-img" :src='`data:image/png;base64, ${persona.mspersonaimagen}`'></v-img>
               </v-avatar>
              <div class="infos">
                <div class="text-uppercase font-weight-medium primary-color h5 ma-0">
                  {{ persona.mspersonanombre }} {{ persona.mspersonaapellido1 }}
                </div>
                <div class="birth grey--text text--darken-1 font-weight-medium w-100">
                  {{ persona.mspersonaemail }}
                </div>
                <div class="email grey--text text--darken-1">
                  {{ persona.mspersonadni }}
                </div>
                <div class="phone grey--text text--darken-1">
                  {{ persona.mspersonatelmovil }}
                </div>
                <div class="nationality text-uppercase ">
                  {{ persona.mspersonapoblacion }}
                </div>
              </div>
                  <!-- <i class="icon-pencil" @click="editarPersona(persona.mspersonauid)" data-text="Editar"></i> -->
              <v-btn flat absolute top right dark icon class="orange" @click="editarPersona(persona.mspersonauid)">
                  <v-icon>edit</v-icon>
               </v-btn>
               <v-btn flat absolute top right icon dark class="primary" @click.stop='removePersona(persona)'>
                 <v-icon >delete</v-icon>
                </v-btn>
            
                  <!-- <i class="icon-minus2" @click="removePersona(persona)" data-text="Quitar"></i> -->
              </v-card>
            </div>
          </div> 
        </main>
      </div>
      <!-- Footer de botones -->
      <!-- FIN. Footer de botones -->
    </div>
     <v-dialog v-model="dialog2" name="search1" class="pa-0">
        <div  class="pa-0 search">
           <v-toolbar flat class="d-flex justify-space-between">
                 
          <v-toolbar-title class="primary-color">
            <v-icon class="mr-3 primary-color">person_add</v-icon>
            Crear nuevo empleado</v-toolbar-title>
          <v-btn @click="dialog2 = false"
            icon
            flat
            class="primary-color">
          <!--<img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' >-->
          <!--{{ $t('lang.comun.salir') }}-->
          <v-icon>close</v-icon>
        </v-btn></v-toolbar>
         <CreatePersona @recargaPersonas="init" />
        </div>
     </v-dialog>
    <!--modal-->
    <v-dialog v-model="dialog1" name="search" class="pa-0">
      <div id="search"  class="pa-0 search">
        <v-btn @click='anadirEmpleado()'
               flat
                fab
                absolute
                bottom
                right
                dark
               class="orange guardar">
        <!--<img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif' >-->
        <v-icon >add</v-icon>
        <!--{{ $t('lang.personas.addempleado') }}-->
        </v-btn>
        <v-toolbar flat class="d-flex justify-space-between">
          <v-toolbar-title class="primary-color">
            <v-icon class="mr-3 primary-color">manage_accounts</v-icon>
            Selecciona y añade empleado
            </v-toolbar-title>
          <v-btn @click="dialog1 = false"
            icon
            flat
            class="primary-color">
          <!--<img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' >-->
          <!--{{ $t('lang.comun.salir') }}-->
          <v-icon>close</v-icon>
        </v-btn></v-toolbar> 
        <div class="pa-4">
          <vue-select class="select-search w-100" :options="personasCompletas" label="mspersonanombre" v-model='personaAdd' :clearable="false" :value="personasCompletas.mspersonaid">
            <template slot="option" slot-scope="option">
               <v-avatar
                size="60px"
              >
                <img
                  style="width:80px;"
                  v-if='option.mspersonaimagen === null || option.mspersonaimagen === "" || option.mspersonaimagen == undefined'
                  :src='require("@/assets/images/no_photo.png")'
                >
                <v-img
                  v-else
                  class="error-img" :src='`data:image/png;base64, ${option.mspersonaimagen}`'
                ></v-img>
               </v-avatar>
              <div class="option">
                {{ option.mspersonaapellido1 ? option.mspersonaapellido1 : '' }}
                {{ option.mspersonaapellido2 ? option.mspersonaapellido2 : '' }}
                {{ option.mspersonanombre ? ' ' + option.mspersonanombre : '' }}
                {{ option.mspersonaalias ? ' (' + option.mspersonaalias + ')' : '' }}
              </div>
            </template>
            <span slot="no-options">No hay resultados</span>
          </vue-select>
        </div>
          <!-- <img
          class='btn-generico'
          :class='{ disabled : !isPersonaAddSelected }'
          :src='require("@/assets/images/Btn-mas.gif")'
          @click='addPersona'
          :disabled='!isPersonaAddSelected'
          :alt='msj.anhadir'
        /> -->
          <v-card class="pl-3 ficha mx-4 py-2"  v-show="isPersonaAddSelected" >
            
           <v-avatar
                size="100px"
                class="mr-4"
              >
              <v-img class="avatar" v-if='personaAdd.mspersonaimagen === null || personaAdd.mspersonaimagen === "" || personaAdd.mspersonaimagen == undefined' :src='require("@/assets/images/no_photo.png")'>
              </v-img>
              <v-img 
                v-else
                class="error-img" :src='`data:image/png;base64, ${personaAdd.mspersonaimagen}`' contain>
              </v-img>
          </v-avatar>    
              <div class="infos">
                <div class="name text-uppercase font-weight-medium primary-color h5 ma-0">
                  {{ personaAdd.mspersonanombre }} {{ personaAdd.mspersonaapellido1 }}
                </div>
                <div class="birth grey--text text--darken-1 font-weight-medium ">
                  {{ personaAdd.mspersonaemail }}
                </div>
                <div class="email grey--text text--darken-1">
                  {{ personaAdd.mspersonadni }}
                </div>
                <div class="phone grey--text text--darken-1 subheading">
                  {{ personaAdd.mspersonatelmovil }}
                </div>
                <div class="nationality text-uppercase">
                  {{ personaAdd.mspersonapoblacion }}
                </div>
              </div>
        </v-card>       
      </div>
 
    </v-dialog>
    <!---->
  </div>
</template>
<script>
import { PersonaApiService } from '@/api/PersonaApiService'
import { Util } from '@/api/Util'
import CreatePersona from '@/views/CreatePersona'

const personaApiService = new PersonaApiService()
const util = new Util()

export default {
  data () {
    return {
      dialog1: false,
      dialog2: false,
      personaLogin: {},
      personas: [],
      personasCompletas: [],
      urlImagen: process.env.VUE_APP_URL_API_PERSONA + 'getPersonaFoto/',
      personaAdd: 0,
      opUid: this.$store.getters.getOpuid,
      opId: this.$store.getters.getIdTienda,
      userid: this.$route.query.userid,
      useruid: this.$route.query.useruid,
      showModal: false,
      msj: {
        quitarpersona: this.$t('lang.msjconfirm.quitarpersona'),
        continuarsinguardar: this.$t('lang.msjconfirm.continuarsinguardar'),
        grabardatos: this.$t('lang.comun.grabardatos'),
        grabarfoto: this.$t('lang.comun.grabarfoto'),
        borrarfoto: this.$t('lang.comun.borrarfoto'),
        totalper: this.$t('lang.personas.totalper'),
        addpersona: this.$t('lang.personas.addpersona'),
        quitar: this.$t('lang.comun.quitar'),
        anhadir: this.$t('lang.comun.anhadir'),
        siguiente: this.$t('lang.comun.siguiente'),
        anterior: this.$t('lang.comun.anterior'),
        grabarfestivo: this.$t('lang.comun.grabarfestivo'),
        borrarfestivo: this.$t('lang.comun.borrarfestivo')
      },
      shift: false,
      ctrl: false,
      lang: this.$route.query.lang,
      perMant: true
    }
  },
  props: {
    tiUid: {
      type: String,
      required: false,
      default: ''
    }
  },
  components: {
     CreatePersona,
  },
  created () {
    if (!this.$store.getters.isLoggedIn && this.tiUid !== '') {
      //viene del tpv hacemos un login especial
      this.$store.dispatch("loginStaff", { user: 'xxxx', password: 'yyyy', op: this.tiUid })
        .then(() => {
            this.opUid = this.tiUid
            this.$store.state.staffControl = true
            this.init2()
          })
          .catch(error => {
            console.log(error)
            this.$router.push('/logout')
          })
    } else {
      this.init2()
    }
      
    // this.cambioTitulo()
    // this.init()
    // this.mountListenerTeclas()
    // // Guardamos el usuario en sesion
    // if (this.userid) {
    //   sessionStorage.setItem('userid', this.userid)
    // }
    // if (this.useruid) {
    //   sessionStorage.setItem('useruid', this.useruid)
    //   this.findPersona()
    // }
    // if (this.opUid) {
    //   sessionStorage.setItem('opUid', this.opUid)
    // }
    // if (this.lang) {
    //   sessionStorage.setItem('lang', this.lang)
    // } else { // por defecto castellano
    //   sessionStorage.setItem('lang', 'es')
    // }
  },
  computed: {
    totalPersonas: function () {
      if (this.personas) {
        return this.personas.length
      } else {
        return 0
      }
    },
    personasMostrar: function () {
      return this.personas
    },
    isPersonaAddSelected: function () {
      if (this.personaAdd === 0) {
        return false
      } else {
        return true
      }
    },
    cambiotienda () {
      return this.$store.getters.getOpuid;
    },
    cambiotiendaId () {
      return this.$store.getters.getIdTienda;
    }
  },
  watch: {
    cambiotienda (value) {
      this.opUid = value;
      // this.init();
    },
    cambiotiendaId (value) {
      this.opId = value;
      this.init()
    },
  },
  methods: {
    init () {
      this.getPersonasByOpId(this.opId)
      this.getPersonasSelect(this.opId)
    },
    init2() {
      this.cambioTitulo()
      this.init()
      this.mountListenerTeclas()
      // Guardamos el usuario en sesion
      if (this.userid) {
        sessionStorage.setItem('userid', this.userid)
      }
      if (this.useruid) {
        sessionStorage.setItem('useruid', this.useruid)
        this.findPersona()
      }
      if (this.opUid) {
        sessionStorage.setItem('opUid', this.opUid)
      }
      if (this.lang) {
        sessionStorage.setItem('lang', this.lang)
      } else { // por defecto castellano
        sessionStorage.setItem('lang', 'es')
      }
    },
    cambioTitulo () {
      this.$store.state.tituloIcono = `<v-icon class="v-icon material-icons primary-color">group</v-icon>`
      this.$store.state.titulo = "Personal"
    },
    anadirEmpleado () {
     this.addPersona()
    },
    mountListenerTeclas () {
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 35) {
          this.anadirEmpleado()
        } else if (e.keyCode === 27) { // ESC
          this.showModal = false
        }
      })
    },
    editarPersona (personauid) {
        this.$router.push({ name: 'persona', params: {empleadouid: personauid }})
    },
    getAllPersona () {
      personaApiService.getAllPersona()
        .then(data => {
          util.mostrarEnConsola('Personas - getAllPersona', data.length, 'OK')
          this.personas = data
        })
        .catch(error => {
          util.mostrarEnConsola('Personas - getAllPersona', error, 'ERROR')
        })
    },
    getPersonasByOpId (OpId) {
      if (OpId) {
        personaApiService.getPersonasByOpId(OpId)
          .then(data => {
            util.mostrarEnConsola('Personas - getPersonasByOpId', data.length, 'OK')
            this.personas = data
            if (this.personas.length > 0) {
              for (let i = 0; i < this.personas.length; i++) {
                if (this.personas[i].mspersonapais === null || this.personas[i].mspersonapais === '') {
                  this.personas[i].mspersonapais = '0'
                }
                if (this.personas[i].mspersonaprovincia === null || this.personas[i].mspersonaprovincia === '') {
                  this.personas[i].mspersonaprovincia = '0'
                }
                if (this.personas[i].mspersonasexo === null || this.personas[i].mspersonasexo === '') {
                  this.personas[i].mspersonasexo = '0'
                }
                this.personas[i].isSelected = false
              }
            }
          })
          .catch(error => {
            util.mostrarEnConsola('Personas - getPersonasByOpId', error, 'ERROR')
          })
      }
    },
    getPersonaById (personaid) {
      personaApiService.getPersonaById(personaid)
        .then(data => {
          util.mostrarEnConsola('Personas - getPersonaById', data.length, 'OK')
          this.personas = data
        })
        .catch(error => {
          util.mostrarEnConsola('Personas - getPersonaById', error, 'ERROR')
        })
    },
    findPersona () {
      if (this.useruid) {
        personaApiService.findPersona({mspersonauid: this.useruid})
          .then(data => {
            if (data.mspersonaid) {
              util.mostrarEnConsola('Personas - findPersona', data.mspersonaid, 'OK')
              this.personaLogin = data
              sessionStorage.setItem('persona', this.personaLogin)
              sessionStorage.setItem('userid', this.personaLogin.mspersonaid)
            }
          })
          .catch(error => {
            this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
            util.mostrarEnConsola('Personas - findPersona', error, 'ERROR')
          })
      }
    },
    getImgUrl: function (mspersonauid) {
      return this.urlImagen + mspersonauid + '?' + Math.random()
    },
    getPersonasSelect (Opid) {
      if (Opid) {
        personaApiService.getPersonasNotInOpId(Opid)
          .then(data => {
            util.mostrarEnConsola('Personas - getPersonasSelect', data.length, 'OK')
            this.personasCompletas = data
          })
          .catch(error => {
            this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
            util.mostrarEnConsola('Personas - getPersonasNotInOpUid', error, 'ERROR')
          })
      }
    },
    addPersona () {
      if (this.personaAdd !== 0) { // Comprobamos si hay persona seleccionada en el select
        for (let i = 0; i < this.personasCompletas.length; i++) {
          const per = this.personasCompletas[i]
          per.isSelected = false
          if (per.mspersonaid === this.personaAdd.mspersonaid) {
            // Guardamos la seleccion en la base de datos
            // TO-DO Gestionar el rol
            personaApiService.createPersonaOp(per.mspersonaid, per.mspersonauid, this.opId, this.opUid, 2)
              .then(data => {
                this.personas.push(per)
                this.personasCompletas.splice(i, 1)
                this.personaAdd = 0
                this.personasMostrar[this.personasMostrar.length - 1].isSelected = true
                util.mostrarEnConsola('Personas - createPersonaOp', 'mspersonaid: ' + per.mspersonaid + ', opUid: ' + this.opUid + ', RESPONSE: ' + data, 'OK')
              })
              .catch(error => {
                this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
                util.mostrarEnConsola('Personas - createPersonaOp', error, 'ERROR')
              })
            break
          }
        }
      }
    },
    removePersona (persona) {
      if (persona) {
        this.$root.$confirm.open('Borrar', this.msj.quitarpersona, { color: 'primary' }).then((confirm) => {
          if (confirm) {
            // Borramos la relacion de la persona con la op
            // TO-DO Gestionar el rol
            personaApiService.deletePersonaOp(persona.mspersonaid, persona.msperosnauid, this.opId, this.opUid, 2)
              .then(data => {
                if (data.deleted) {
                  util.mostrarEnConsola('Personas - deletePersonaOp', 'mspersonaid: ' + persona.mspersonaid + ', opUid: ' + this.opUid + ', RESPONSE: ' + data.deleted, 'OK')
                  // Devolvemos la persona a la lista de personas seleccionables
                  this.personasCompletas.push(persona)
                  // Reordenamos personasCompletas
                  this.personasCompletas.sort((a, b) => (a.mspersonaapellido1 > b.mspersonaapellido1) ? 1 : (a.mspersonaapellido1 === b.mspersonaapellido1) ? ((a.mspersonanombre > b.mspersonanombre) ? 1 : -1) : -1)
                  // Quitamos la persona de las personas
                  for (let i = 0; i < this.personas.length; i++) {
                    if (persona.mspersonaid === this.personas[i].mspersonaid) {
                      this.personas.splice(i, 1)
                      break
                    }
                  }
                  // Quitamos la persona de las personasMostrar
                  for (let j = 0; j < this.personasMostrar.length; j++) {
                    if (persona.mspersonaid === this.personasMostrar[j].mspersonaid) {
                      this.personasMostrar.splice(j, 1)
                      break
                    }
                  }
                }
              })
              .catch(error => {
                this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
                util.mostrarEnConsola('Personas - deletePersonaOp', error, 'ERROR')
              })
          }
        })
      }
    },
  }
}
</script>
